import { render, staticRenderFns } from "./CardSingleRecipe.vue?vue&type=template&id=eb3a0d2c&scoped=true"
import script from "./CardSingleRecipe.vue?vue&type=script&lang=js"
export * from "./CardSingleRecipe.vue?vue&type=script&lang=js"
import style0 from "./CardSingleRecipe.vue?vue&type=style&index=0&id=eb3a0d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3a0d2c",
  null
  
)

export default component.exports